<div container>
  <div style="height: 8px; background-color: rgba(16, 46, 94, 0.982)" class="col-12"></div>

  <h2
    class="mb-0"
    style="padding-left: 15px; padding-bottom: 10px"
    style="cursor: grabbing"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
    mat-dialog-title
    >
    Détails des agents sur poste
  </h2>
  <button (click)="closepopup()" mat-dialog-close class="btnClose" mat-icon-button aria-label="Fermer la fenêtre">
    <mat-icon>close</mat-icon>
  </button>

  @if (hasAgents) {
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="Nom">
        <th mat-header-cell *matHeaderCellDef>Nom</th>
        <td mat-cell *matCellDef="let element">{{ element.nom }}</td>
      </ng-container>
      <ng-container matColumnDef="Fonction">
        <th mat-header-cell *matHeaderCellDef>Fonction</th>
        <td mat-cell *matCellDef="let element">{{ element.fonction }}</td>
      </ng-container>
      <ng-container matColumnDef="Age">
        <th mat-header-cell *matHeaderCellDef>Age</th>
        <td mat-cell *matCellDef="let element">{{ element.age }}</td>
      </ng-container>
      <ng-container matColumnDef="Type contrat">
        <th mat-header-cell *matHeaderCellDef>Type contrat</th>
        <td mat-cell *matCellDef="let element">{{ element.type_contrat }}</td>
      </ng-container>
      <ng-container matColumnDef="Début fin contrat">
        <th mat-header-cell *matHeaderCellDef>Début fin contrat</th>
        <td mat-cell *matCellDef="let element">{{ element.debut_fin_contrat }}</td>
      </ng-container>
      <ng-container matColumnDef="Taux emploi">
        <th mat-header-cell *matHeaderCellDef>Taux emploi</th>
        <td mat-cell *matCellDef="let element">{{ element.taux_emploi }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  }

  @if (!hasAgents) {
    <div class="message-erreur">
      <em>Il n'y a aucun agent disponible sur ce poste.</em>
    </div>
  }

  <mat-divider></mat-divider>
  <div>
    <button (click)="fermerdialog()" mat-dialog-close class="btnFermer" mat-raised-button color="primary">Fermer</button>
  </div>
</div>
